(function () {
  'use strict';

  function initStickyBuy(bar) {
    if (bar.getAttribute('data-sb-initialized') === 'true') return;
    bar.setAttribute('data-sb-initialized', 'true');

    var prefix = bar.getAttribute('data-prefix');
    var sectionId = bar.getAttribute('data-section-id');
    var nativeBtn = document.getElementById(prefix + '-atc-' + sectionId);
    var stickyBtn = bar.querySelector('[data-sb-atc]');
    var price = bar.querySelector('[data-sb-price]');
    var selection = bar.querySelector('[data-sb-selection]');
    var grundpreis = bar.querySelector('[data-sb-grundpreis], .sb-bar__grundpreis');
    function setGrundpreis(text) {
      if (!grundpreis) return;
      grundpreis.textContent = text || '';
      grundpreis.hidden = !text;
    }
    var stickyImage = bar.querySelector('.sb-bar__image');
    var fallbackImageSrc = stickyImage ? stickyImage.getAttribute('src') : '';
    var sectionRoot = document.getElementById(prefix + '-' + sectionId);

    if (!nativeBtn || !stickyBtn) return;

    function setVisible(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function syncAvailability(variantBtn) {
      var unavailable = variantBtn.getAttribute('data-available') === 'false';
      stickyBtn.disabled = unavailable;
      stickyBtn.textContent = unavailable ? 'Ausverkauft' : 'In den Warenkorb';
    }

    function syncVariant(variantPrice, variantImage, available) {
      if (price && variantPrice !== null && variantPrice !== undefined) {
        price.textContent = /^\d+$/.test(String(variantPrice))
          ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(variantPrice) / 100)
          : variantPrice;
      }
      if (stickyImage) stickyImage.src = variantImage || fallbackImageSrc;
      stickyBtn.disabled = !available;
      stickyBtn.textContent = available ? 'In den Warenkorb' : 'Ausverkauft';
    }

    stickyBtn.disabled = nativeBtn.disabled;
    if (nativeBtn.disabled) stickyBtn.textContent = 'Ausverkauft';

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        setVisible(!entries[0].isIntersecting);
      }, { threshold: 0.1 }).observe(nativeBtn);
    } else {
      var updateFallbackVisibility = function () {
        setVisible(window.scrollY >= 600);
      };
      window.addEventListener('scroll', updateFallbackVisibility, { passive: true });
      updateFallbackVisibility();
    }

    document.addEventListener('click', function (event) {
      var variantBtn = event.target.closest('[data-variant-id]');
      if (!variantBtn || !sectionRoot || !sectionRoot.contains(variantBtn)) return;

      window.setTimeout(function () {
        var variantPrice = variantBtn.getAttribute('data-variant-price');
        var variantImage = variantBtn.getAttribute('data-variant-img');
        if (price && variantPrice) {
          price.textContent = /^\d+$/.test(variantPrice)
            ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(variantPrice) / 100)
            : variantPrice;
        }
        if (stickyImage) stickyImage.src = variantImage || fallbackImageSrc;
        var unitPrice = variantBtn.getAttribute('data-unit-price');
        var unitRef = variantBtn.getAttribute('data-unit-ref');
        setGrundpreis(unitPrice && unitRef
          ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(unitPrice) / 100) + ' / ' + unitRef
          : '');
        syncAvailability(variantBtn);
      }, 0);
    });

    document.addEventListener('pdp:variant', function (event) {
      var detail = event.detail || {};
      if (String(detail.sectionId) !== String(sectionId) || detail.prefix !== prefix) return;
      syncVariant(detail.priceCents, detail.img, detail.available);
    });

    if (sectionRoot) {
      sectionRoot.addEventListener('pdp:selection', function (event) {
        if (selection) selection.textContent = event.detail.quantity + ' Stück';
        if (price) price.textContent = event.detail.price;
        if (event.detail.grundpreis !== undefined) setGrundpreis(event.detail.grundpreis);
      });
    }

    stickyBtn.addEventListener('click', function () {
      if (nativeBtn.disabled || stickyBtn.disabled) return;
      nativeBtn.click();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sticky-buy]').forEach(initStickyBuy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
